import EditorField from "../../Utils/EditorField"
import { careerProfileLabels } from "../../Types/careerProfileLabels"
const WorkGoals = ({ formik }) => {
  return (
    <>
      <EditorField
        value={formik.values.workGoals_1}
        onTextChange={formik.setFieldValue}
        valueName={careerProfileLabels.workGoals.workGoals_1.value}
        label={careerProfileLabels.workGoals.workGoals_1.label}
      />
      <EditorField
        value={formik.values.workGoals_2}
        onTextChange={formik.setFieldValue}
        valueName={careerProfileLabels.workGoals.workGoals_2.value}
        label={careerProfileLabels.workGoals.workGoals_2.label}
      />
      <EditorField
        value={formik.values.workGoals_3}
        onTextChange={formik.setFieldValue}
        valueName={careerProfileLabels.workGoals.workGoals_3.value}
        label={careerProfileLabels.workGoals.workGoals_3.label}
      />
      <EditorField
        value={formik.values.workGoals_4}
        onTextChange={formik.setFieldValue}
        valueName={careerProfileLabels.workGoals.workGoals_4.value}
        label={careerProfileLabels.workGoals.workGoals_4.label}
      />
      <EditorField
        value={formik.values.workGoals_5}
        onTextChange={formik.setFieldValue}
        valueName={careerProfileLabels.workGoals.workGoals_5.value}
        label={careerProfileLabels.workGoals.workGoals_5.label}
      />
      <EditorField
        value={formik.values.workGoals_6}
        onTextChange={formik.setFieldValue}
        valueName={careerProfileLabels.workGoals.workGoals_6.value}
        label={careerProfileLabels.workGoals.workGoals_6.label}
      />
    </>
  )
}
export default WorkGoals
